/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { makeRequired, makeValidate, SelectData } from "mui-rff";
import { schema } from "@/features/clients/create/validations";
import { makeYupTranslatedError } from "@/helpers/yup";
import Page from "@/components/page";
import { useTranslation } from "react-i18next";
import AccordionForm from "@/features/clients/create/components/AccordionForm";
import { TAccordionForm } from "@/features/clients/create/types";
import { toastError, toastSuccess } from "@/helpers/toast";
import { getCustomer, saveCustomer } from "@/apis/customer";
import { Box } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import lGet from "lodash/get";
import { convertJSONToString, errorMessageFromServer } from "@/utils/server";
import BackDrop from "@/components/backdrop/BackDrop";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { useSelector } from "react-redux";
import { selectIsRegisterCompleted } from "@/store/slices/authSlice";
import { goURL } from "@/helpers/router";
import { checkErrorResponse } from "@/helpers/axios";
import { useCurrentPath } from "@/hooks/useCurrentPath";
import { getCatalogCountries } from "@/apis/catalogs/Address";
import { concatSelectData, transformCatalog } from "@/helpers/generic-transformer";
import { getCatalogTaxRegimes } from "@/apis/catalogs/invoices";
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const ClientWizard = ({ isModal, callback, customer_id, icon, callbackList, isModalInvoice, isHeaderBtn, from = "route" }: any): any => {
    //console.log('@ClientWizard loading component from ', from);

    const path: any = useCurrentPath();
    const modalHeaderCallback = () => {
        console.log('modalHeaderCallback path', path);
        console.log('modalHeaderCallback path typeof', typeof path);
        if (path === '/list/customers') {
            console.log('reload path customers list');
            history.go(0)
        }
    }

    // obtener si ya completó registro
    const register_complete: boolean = useSelector(selectIsRegisterCompleted);

    // for redirect if edition is from full page
    const history = useHistory();

    // check if client id is on url
    const { client_id }: any = useParams<any>();

    // set customerId if exists
    const customerId = isModal ? (customer_id || null) : (client_id || null);

    // translations
    const [t] = useTranslation();

    // backdrop loader
    const [loading, setLoading] = useState(false);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    const [loadedData, setLoadedData] = useState(false);

    // submit
    const [submitting, setSubmitting] = useState(false);

    // validations
    const validateForm = makeValidate(schema, makeYupTranslatedError);
    const required = makeRequired(schema);

    // initials
    const initialValues: any = {
        // first step
        customers_rfc: 'XAXX010101000',
        customers_name: '',
        address_pais: { label: 'México', value: '1' },
        customers_email: '',
        customers_num_regid_trib: '',
        cat_tax_regime_id: { label: "601 - General de Ley Personas Morales", value: "1" },

        // second step
        address_tipo: '',
        address_calle: '',
        address_no_exterior: '',
        address_no_interior: '',
        address_colonia: '',
        address_referencia: '',
        address_municipio: '',
        address_localidad: '',
        address_estado: '',
        address_codigo_postal: '',

        // third step
        customers_telefono: '',
        customers_fax: '',
        customers_email_2: '',
        customers_email_3: '',
        customers_pagina_web: '',
    };
    const initialValuesRef = useRef<any>(initialValues);

    // countries catalog
    const selectDataCountry: SelectData[] = [];
    const selectDataCountryRef = useRef<SelectData[]>(selectDataCountry);

    // regime catalog
    const selectDataRegime: SelectData[] = [];
    const selectDataRegimeRef = useRef<SelectData[]>(selectDataRegime);

    // yes, this can even be async!
    const onSubmit = async (values: any) => {
        return await submitData(values); // reducing code with await
    };

    // real submit data
    const submitData = useCallback(async (payload: any) => {
        // set loaders states
        setSubmitting(true);
        setLoading(true);

        try {
            // attach customer id
            if (customerId) {
                payload = {
                    ...payload,
                    customer_id: customerId
                }
            }

            payload = {
                ...payload,
                address_pais: payload.address_pais.value, // fix object to string value,
                cat_tax_regimes_id: payload.cat_tax_regime_id.value, // fix object to string value,
            };

            console.log('payload', payload);

            // call api
            const response = await saveCustomer(payload);

            // show message
            const message = response.data.status;
            toastSuccess(message);

            // redirect to list uri if exists param in url
            if (client_id || !isModal) {
                history.push('/list/customers')
            }

            // call callback from list
            if (callbackList) {
                callbackList();
            }

            // executing callback if exist
            if (callback) {
                // send with data and close modal, mark if is new or edit on callback
                callback(response.data.customer_data, (!customerId));
            }

            // close modal
            return true;
        } catch (error) {
            // error api custom Request
            if (lGet(error, 'data')) {
                const errors = error.data.errors;
                const message = errorMessageFromServer(convertJSONToString(errors));
                toastError(message);
            } else {
                // another error
                console.error('error: ', error);
                checkErrorResponse(error);
            }

            // don't close modal
            return false;
        } finally {
            // reset loaders states
            setSubmitting(false);
            setLoading(false);
        }
    }, []);

    // get data for catalogs and customer if exists id
    const getData = useCallback(async () => {
        // set loaders states
        setLoading(true);

        try {
            // call catalogs for this interface

            // country catalog
            const countriesResponse = await getCatalogCountries();
            const countries_select_data: SelectData[] = transformCatalog(countriesResponse.data.countries, 'name', 'id', true);
            selectDataCountryRef.current = concatSelectData(selectDataCountryRef.current, countries_select_data);

            // tax regimes catalog
            const taxRegimeResponse = await getCatalogTaxRegimes();
            const regime_select_data: SelectData[] = transformCatalog(taxRegimeResponse.data.tax_regimes, 'label', 'id', true);
            selectDataRegimeRef.current = concatSelectData(selectDataRegimeRef.current, regime_select_data);

            // call this when customer id exists
            if (customerId) {
                // create GET Axios config for request
                const config: AxiosRequestConfig = {
                    params: {
                        id: customerId
                    }
                }

                // call api
                const response: AxiosResponse = await getCustomer(config);

                // set customer to unfurl
                const customer: object = response.data.customer_data;

                // set initial values with customer data
                await formatCustomerData(customer);
            }

            // to know if data was loaded on first load
            setLoadedData(true);
        } catch (error) {
            // error api custom Request
            if (lGet(error, 'data')) {
                const errors = error.data.errors;
                const message = errorMessageFromServer(convertJSONToString(errors));
                toastError(message);
            } else {
                console.error('error: ', error);
                checkErrorResponse(error);
            }
        } finally {
            // reset loaders states
            setLoading(false);
        }

    }, []);

    // format customer data to initial values
    const formatCustomerData = async (customer: any) => {
        const valueCountry: any = selectDataCountryRef.current.find((country: any) => {
            return country.value === customer.address.pais
        })

        const valueRegime: any = selectDataRegimeRef.current.find((regime: any) => {
            return regime.value === `${customer.cat_tax_regimes_id}`
        });

        initialValuesRef.current = {
            customers_rfc: customer.rfc,
            customers_name: customer.name,
            address_pais: valueCountry || { label: 'México', value: '1' },
            customers_email: customer.email,
            customers_num_regid_trib: customer?.num_regid_trib || '',
            cat_tax_regime_id: valueRegime || { label: "601 - General de Ley Personas Morales", value: "1" },

            // second step
            address_tipo: customer.address.tipo,
            address_calle: customer.address?.calle || '',
            address_no_exterior: customer.address?.no_exterior || '',
            address_no_interior: customer.address?.no_interior || '',
            address_colonia: customer.address?.colonia || '',
            address_referencia: customer.address?.referencia || '',
            address_municipio: customer.address?.municipio || '',
            address_localidad: customer.address?.localidad || '',
            address_estado: customer.address?.estado || '',
            address_codigo_postal: customer.address.codigo_postal,

            // third step
            customers_telefono: customer?.telefono || '',
            customers_fax: customer?.fax || '',
            customers_email_2: customer?.email_2 || '',
            customers_email_3: customer?.email_3 || '',
            customers_pagina_web: customer?.pagina_web || '',
        };
    }

    // mount component
    useEffect(() => {
        /*if (!register_complete) {
            goURL('/complete/register/Y29tcGxldGUgcmVnaXN0ZXIK');
        } else {
            getData().catch((e: any) => console.error(e));
        }*/

        if (!isModal && !isModalInvoice) {
            //console.log("cargar datos porque no es modal");
            getData().catch((e: any) => console.error(e));
        } else {
            //console.log("cargar datos hasta que abra modal");
        }
    }, [])

    useEffect(() => {
        //console.log("@ClientWizard sensing value modalOpen: ", modalOpen);
        if (modalOpen && !loadedData) {
            //console.log("@ClientWizard modal is open and not loaded data first time");
            getData().catch((e: any) => console.error(e));
        }
    }, [modalOpen])

    // props for form
    const formProps: TAccordionForm = {
        initialValues: initialValuesRef.current,
        onSubmit,
        required,
        selectDataCountry: selectDataCountryRef.current,
        selectDataRegime: selectDataRegimeRef.current,
        submitting,
        validateForm,
        isModal,
        icon,
        callback: isHeaderBtn ? modalHeaderCallback : null,
        setModalOpen,
        loading
    }

    // render
    return (
        <>
            {/*{
                (!isModalInvoice && !isModal) && (
                    <BackDrop open={loading} text={t("common.loading")} />
                )
            }*/}
            {
                (!isModalInvoice && !isModal) && (
                    <Page
                        title={t("clients.title")}
                    >
                        {!loading &&
                            <Box
                                sx={{
                                    ...(!isModal && {
                                        mt: 2,
                                    }),
                                }}
                            >
                                <AccordionForm {...formProps} />
                            </Box>
                        }
                        {loading && <SimpleSpinner />}
                    </Page>
                )
            }

            {
                (isModal || isModalInvoice) && (
                    <Box>
                        <AccordionForm {...formProps} />
                    </Box>
                )
            }
        </>
    );
}

export default ClientWizard
